/**
 * @file LocaleToggle.tsx
 * @description
 * -----------------------------------------------------
 * Archivo que contiene el componente para cambiar
 * de locale (entre español e inglés)
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-03-26
 * @modified 2025-04-21
 * @author DLTCode
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import { useLocale, useTranslations } from "next-intl";
import { LanguagesIcon } from "lucide-react";
import { getCurrentLocale, getNextLocale } from "@/lib/localization";
import ButtonComponent from "@/components/ui/ButtonComponent";
import useLocaleChange from "@/hooks/useLocaleChange";
const LocaleToggle = () => {
  const $ = _c(19);
  const locale = useLocale();
  const [, handleLocaleChange] = useLocaleChange();
  const t = useTranslations("LocaleToggle");
  let t0;
  if ($[0] !== locale) {
    t0 = getNextLocale(locale);
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const nextLocale = t0;
  let currentLocale;
  let t1;
  if ($[2] !== locale || $[3] !== t) {
    currentLocale = getCurrentLocale(locale);
    t1 = t(currentLocale);
    $[2] = locale;
    $[3] = t;
    $[4] = currentLocale;
    $[5] = t1;
  } else {
    currentLocale = $[4];
    t1 = $[5];
  }
  const visibleText = t1;
  const nextLocaleText = nextLocale === "es" ? "Espa\xF1ol" : "English";
  const currentLocaleText = currentLocale === "es" ? "Espa\xF1ol" : "English";
  let t2;
  if ($[6] !== t) {
    t2 = t("languagesIconLabel");
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t) {
    t3 = t("currentLanguage");
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const accessibilityLabel = `${t2} ${nextLocaleText}. ${t3} ${currentLocaleText}`;
  let t4;
  if ($[10] !== handleLocaleChange || $[11] !== nextLocale) {
    t4 = () => handleLocaleChange(nextLocale);
    $[10] = handleLocaleChange;
    $[11] = nextLocale;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      flexShrink: 0
    };
    t6 = <LanguagesIcon size={24} role="img" aria-hidden={true} />;
    $[13] = t5;
    $[14] = t6;
  } else {
    t5 = $[13];
    t6 = $[14];
  }
  let t7;
  if ($[15] !== accessibilityLabel || $[16] !== t4 || $[17] !== visibleText) {
    t7 = <ButtonComponent onClick={t4} title={accessibilityLabel} aria-label={accessibilityLabel} variant="plain" style={t5}>{t6}{visibleText}</ButtonComponent>;
    $[15] = accessibilityLabel;
    $[16] = t4;
    $[17] = visibleText;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export default LocaleToggle;